import classNames from 'classnames';
import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import ErrorIndicator from '../components/ErrorIndicator';
import LoadingIndicator from '../components/LoadingIndicator';
import { PanelHeader } from '../components/designer/panels/PanelHeader';
import HeaderDataset from '../components/headers/HeaderDataset';
import { Container } from '../components/layout/ContainerFlex';
import { ContainerMain } from '../components/layout/ContainerMain';
import { ContainerSidebar } from '../components/layout/ContainerSidebar';
import DatasetObjectEditorSidebar from '../datasetObject/sidebar/DatasetObjectEditorSidebar';
import DatasetObjectPipelineSidebar from '../datasetObject/sidebar/DatasetObjectPipelineSidebar';
import WarehouseContainer from '../warehouse/WarehouseContainer';
import DatasetProcessingAutomationDataView from './DatasetProcessingAutomationDataView';
import DatasetProcessingAutomationMenuSidebar from './sidebar/DatasetProcessingAutomationMenuSidebar';

const DatasetProcessingAutomationRoot: React.FC = () => {
  const { t } = useTranslation('dataset');
  const isLoading = false; //loadStatus === AsyncLoadStatus.Loading;
  const hasError = false; // loadStatus === AsyncLoadStatus.Error;
  const isReady = true; //loadStatus === AsyncLoadStatus.Ok;

  return (
     <WarehouseContainer fullHeaders={true}>
      
      <HeaderDataset title={t`Integration (Jobs & Pipelines)`} />
      <ContainerMain
        className="flex"
        data-component="DatasetProcessingAutomationRoot"
      >
        {hasError && <ErrorIndicator selfCenter message={t`Error`} />}

        {isLoading && <LoadingIndicator selfCenter message={t`Loading... `} />}

        {isReady && (
          <>
            <ContainerSidebar side="left">
              <DatasetProcessingAutomationMenuSidebar />
            </ContainerSidebar>
            <ErrorBoundary
              fallbackRender={({ error, resetErrorBoundary }) => (
                <ErrorIndicator
                  selfCenter
                  message={error.message}
                  hasReloadButton={true}
                  exception={error}
                />
              )}
            >
              <Suspense
                fallback={
                  <Container col hasOverflowY>
                    <PanelHeader isLoading title={t`Loading...`} />
                    <LoadingIndicator
                      className={classNames(
                        'bg-map-area-striped border-app-panel-dark border-8',
                      )}
                      selfCenter
                      message={t`Loading`}
                    />
                  </Container>
                }
              >
                <DatasetProcessingAutomationDataView />
              </Suspense>
            </ErrorBoundary>
            <ContainerSidebar side="right">
              <DatasetObjectPipelineSidebar />
              <DatasetObjectEditorSidebar />
            </ContainerSidebar>
          </>
        )}
      </ContainerMain>
    </WarehouseContainer>
  );
};

export default DatasetProcessingAutomationRoot;
